import { RouteConfig } from "../../types/RouteConfig";
import { applyWorkOppRoute } from "./apply/route";
import { myApplicationsRoute } from "./my-applications/route";
import { myFoodTypesRoute } from "./my-food-types/route";
import { myInvitationsRoute } from "./my-invitations/route";
import { myPostcodesRoute } from "./my-postcodes/route";
import { myWorkOppsRoute } from "./my-events/route";
import { placeEventRoute } from "./place/route";

export const workOppsRoutes: RouteConfig<'with-children'> = {
    name: 'Work Opportunities',
    icon: 'mdi mdi-truck',
    context: 'member',
    children: [applyWorkOppRoute, placeEventRoute, myApplicationsRoute, myInvitationsRoute, myWorkOppsRoute, myPostcodesRoute, myFoodTypesRoute],
}
